import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HIDE_BOOK_DEMO_CARD } from 'ducks/flags/flagNames'
import { doSetFlag } from 'ducks/flags'
import eric from 'assets/eric-stein.jpg'
import { selectCurrentUser } from 'ducks/currentUser'
import useCalendlyWidget from 'util/hooks/useCalendlyWidget'
import FeatureCard from './FeatureCard'

const CALENDLY_URL = 'https://calendly.com/eric-groovehq/walkthrough'

const BookDemoCard = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)

  const handleCloseCard = useCallback(
    () => {
      dispatch(doSetFlag(HIDE_BOOK_DEMO_CARD))
    },
    [dispatch]
  )

  useCalendlyWidget({
    onScheduleSuccess: handleCloseCard,
  })

  const onScheduleClick = useCallback(
    () => {
      if (!window.Calendly) {
        window.open(URL, CALENDLY_URL)
        return
      }
      window.Calendly.initPopupWidget({
        url: CALENDLY_URL,
        hide_gdpr_banner: true,
        prefill: {
          email: currentUser.email,
          name: `${currentUser.first_name} ${currentUser.last_name}`,
        },
      })
    },
    [currentUser]
  )

  if (!currentUser.id) return null

  return (
    <FeatureCard
      icon={<img src={eric} alt="Eric" />}
      title="Want the grand tour?"
      subtitle="Let Eric, our Head of Success give you a 1-1 demo to get you up and running."
      buttonLabel="Schedule a time"
      onClickButton={onScheduleClick}
      onClose={handleCloseCard}
    />
  )
}

export default BookDemoCard
